import Listing from "../types/Listing";

export const listings: Array<Listing> = [
  {
    id: 71326202334,
    header: "Hire an Engineer With 5+ Years of Professional Experience",
    tags: ["jobs"],
    body: "Incidunt culpa accusamus deleniti, nam, facilis cupiditate autem vero mollitia officia excepturi voluptas! Facere dolore doloremque corrupti ullam temporibus ut, nisi tenetur odit id recusandae? Porro, obcaecati qui culpa alias inventore omnis tempora asperiores temporibus.",
    user: {
      firstName: "Roldan",
      lastName: "Gregon",
      avatar: "https://i.pravatar.cc/50?img=51",
    },
    date: "2023-05-30 11:36:32",
    category: "Available For Hire",
  },
  {
    id: 85076416587,
    header: "🚨 Nulla mattis dolor nec nulla semper commodo!",
    tags: ["advice", "mock"],
    body: "Earum, voluptates omnis et nobis eius tempore, quia harum mollitia laborum hic optio? Facilis, dolore explicabo? Deleniti, veritatis blanditiis magnam repellat quibusdam ipsa exercitationem, saepe aliquid doloremque enim numquam non dignissimos vitae eos debitis nobis. Nostrum quaerat, ullam omnis tempore facere ipsa quos optio aperiam.",
    user: {
      firstName: "Edsel",
      lastName: "Capozzi",
      avatar: "https://i.pravatar.cc/50?img=11",
    },
    date: "2023-05-29 10:26:54",
    category: "Education/Courses",
  },
  {
    id: 10396744855,
    header: "Four ways GPT can enhance the travel industry",
    tags: ["technology"],
    body: "Suspendisse vel bibendum elit, eu molestie augue. Nulla mattis dolor nec nulla semper commodo. Morbi ac elit purus. Nullam eget metus quam. Nullam at consectetur est, et vulputate ante. Nunc magna nunc, aliquet eu eros vitae, laoreet faucibus arcu. Aliquam congue consectetur nibh sit amet vulputate. Duis rutrum fringilla hendrerit.",
    user: {
      firstName: "Leighton",
      lastName: "Donahue",
      avatar: "https://i.pravatar.cc/50?img=35",
    },
    date: "2023-05-29 15:12:19",
    category: "Job Listings",
  },
  {
    id: 41373967923,
    header: "The Typescript Compiler API Book",
    tags: ["programming"],
    body: "Phasellus eget gravida elit, ut semper massa. Praesent vulputate in tellus sit amet molestie. Etiam ornare blandit metus, at accumsan ipsum molestie et. Fusce hendrerit libero nec vulputate sagittis. Nam vitae vehicula dolor. Nam ipsum ex, vestibulum ac urna a, dictum viverra nisl. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    user: {
      firstName: "Willow",
      lastName: "Stillwell",
      avatar: "https://i.pravatar.cc/50?img=27",
    },
    date: "2023-05-28 12:46:11",
    category: "Upcoming Events",
  },
  {
    id: 23426556351,
    header: "☕ 2023 State of the Java Ecosystem | Free eBook",
    tags: ["guides"],
    body: "Aliquam imperdiet viverra elementum. Pellentesque et diam aliquam nisl vulputate elementum vel et enim. In hac habitasse platea dictumst. Nam bibendum pellentesque magna et dictum. Ut nec nunc mattis odio mattis iaculis vel at dolor. Ut commodo hendrerit est, vel laoreet urna sodales at.",
    user: {
      firstName: "Irma",
      lastName: "Senton",
      avatar: "https://i.pravatar.cc/50?img=24",
    },
    date: "2023-05-28 14:11:37",
    category: "Products/Tools",
  },
];
